export const TopTabs = ({
  active,
  onChange,
  schedulingEnabled,   // TRUE = 2nd tab usable
  rulesEnabled         // 🔹 NEW: TRUE = 3rd tab visible & usable
}) => {
  const base =
    "flex-1 text-center py-2 rounded-t-md cursor-pointer transition-colors";
  const activeCls = "bg-background border-b-2 border-primary font-medium";
  const inactive = "bg-muted text-muted-foreground hover:bg-muted/70";
  const disabled =
    "bg-muted text-muted-foreground opacity-40 cursor-not-allowed";

  return (
    <div className="flex border-b border-border">
      {/* Employees tab (index 1) */}
      <div
        className={`${base} ${active === 1 ? activeCls : inactive}`}
        onClick={() => onChange(1)}
      >
        Employees
      </div>

      {/* Scheduling tab (index 2) */}
      <div
        className={`${base} ${
          !schedulingEnabled
            ? disabled
            : active === 2
            ? activeCls
            : inactive
        }`}
        onClick={() => {
          if (schedulingEnabled) onChange(2);
        }}
      >
        Scheduling
      </div>

      {/* 🔹 Scheduling Rules tab (index 3) – only when rulesEnabled */}
      {rulesEnabled && (
        <div
          className={`${base} ${
            active === 3 ? activeCls : inactive
          }`}
          onClick={() => onChange(3)}
        >
          Scheduling&nbsp;Rules
        </div>
      )}
    </div>
  );
};